import React from 'react'
import { TextField } from '@mui/material'

function InputText({ compulsoryData, disabled, label, maxLength, multiline, name, onChange, type, value }) {
	const shrinkTypes = ['date', 'time']
	let labelProps = {}
	if (shrinkTypes.includes(type)) {
		labelProps = {
			shrink: true,
		}
	}
	return (<TextField
		className="inputForm"
		fullWidth
		label={compulsoryData && compulsoryData.indexOf(name) != -1 ? `${label} *` : label}
		name={name}
		type={type}
		onChange={onChange}
		value={value}
		inputProps={{
			maxLength: maxLength || '',
			disabled: !!disabled,
		}}
		InputLabelProps={labelProps}
		multiline={!!multiline}
		variant="standard"
	/>)
}

export default InputText
